import React, {Component} from "react";
import TreeSelectModal from "../../../../components/treeSelectModal/TreeSelectModal";
import BaseComponent from "../../../../base/BaseComponent";
import {generateTreeData, treeForEach} from "../../../../utils";

export default class ConfigTreeSelect extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            treeData: [],
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: []
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value || prevProps.flag !== this.props.flag) {
            this.setTreeData();
        }
    }

    componentDidMount() {
        this.setTreeData();
    }

    render() {
        const {
            value,
            checkStrictly,
            multiple,
            onItemDelete,
            placeholder
        } = this.props;

        const {
            treeData,
            autoExpandParent,
            expandedKeys,
            checkedKeys
        } = this.state;

        let valueList = [];
        if (multiple) {
            treeForEach(treeData, node => {
                if (value.includes(node.id)) {
                    valueList.push({
                        label: node.title,
                        value: node.id
                    });
                }
            });
        } else {
            treeForEach(treeData, node => {
                if (node.id === value) {
                    valueList = [{
                        label: node.title,
                        value: node.id
                    }];
                }
            });
        }


        return treeData.length ? <TreeSelectModal
            title="选择栏目"
            valueList={valueList}
            treeData={treeData}
            autoExpandParent={autoExpandParent}
            expandedKeys={expandedKeys}
            onExpand={this.onExpand}
            showIcon={true}
            checkStrictly={checkStrictly}
            checkable={true}
            onCheck={this.onCheck}
            checkedKeys={checkedKeys}
            handleOk={this.handleOk}
            showModalHandle={this.showModalHandle}
            onItemDelete={onItemDelete}
            placeholder={placeholder}
        /> : null;
    }

    onCheck = c => {
        while (c.checked.length > 1) {
            c.checked.shift();
        }
        this.setState({
            checkedKeys: c
        });
    };

    handleOk = () => {
        const {multiple} = this.props;
        const {checkedKeys: {checked}} = this.state;
        let data;
        if (multiple) {
            data = checked;
        } else {
            data = checked[0];
        }
        this.props.onChange(data);
    };

    showModalHandle = () => {
        const {value, checkStrictly, multiple} = this.props;
        let checkedKeys = [];
        if (checkStrictly) {
            if (multiple) {
                checkedKeys = {checked: value};
            } else {
                checkedKeys = {checked: [value]};
            }
        } else {
            checkedKeys = [value];
        }
        this.setState({
            checkedKeys
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    // 获取树数据
    setTreeData = () => {
        const treeDataIndex = {
            id: "id",
            title: "name",
            children: "sons",
            key: "id"
        };
        this.getConfigCategoryTreeRequest(res => {
            const treeData = generateTreeData([res], treeDataIndex);
            const expandedKeys = [];
            treeForEach(treeData, node => {
                if (node.children && node.children.length) {
                    expandedKeys.push(node.id);
                }
            });
            this.onExpand(expandedKeys);
            this.setState({
                treeData
            });
        });
    };

    getConfigCategoryTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/configCategory/getConfigCategoryTree",
            callBack
        });
    };
}

